var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-excel-xlsx',{attrs:{"data":_vm.data,"columns":_vm.columns,"file-name":_vm.fileNameProp,"file-type":'xlsx',"sheet-name":'Kitaplık 1'}},[_c('v-btn',{attrs:{"text":"","color":"success darken-2","disabled":_vm.buttonEnabled}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-microsoft-excel")]),_vm._v(" "+_vm._s(_vm.buttonTitle)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }